module.exports = __webpack_public_path__ + "img/high-limousin.ebd806ea.png";